import React, { useEffect, useState } from "react";
import MUITable from "Components/UI/Tables/MUITable";
import { Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import LinkIcon from "@mui/icons-material/Link";
import cutStrAtAndAddDots from "utils/cutStrAtAndAddDots";
import { price2StringPrice } from "utils/priceformatter";
import CommonChip from "Components/UI/Tables/CommonChip";
import {
  getParseStatusLabelById,
  getSystemStatusLabelById,
} from "utils/labels";
import {
  getSystemStatusColorByLabel,
  getParseStatusColorByLabel,
} from "utils/colors";
import RefreshBtn from "Components/UI/Tables/RefreshBtn";
import { LoadingButton } from "@mui/lab";

const createRows = (accounts) => {
  return accounts.map((a) => {
    return [
      a.Id,

      a.ClientId,
      a.ClientTitle,
      a.InvoiceId,
      a.ClientArticleId,
      a.ClientArticleTitle,
      price2StringPrice(a.Amount === null ? 0 : a.Amount),
      a.PayedId,
      a.BookRefId,
      a.FromAccount,
      a.ToAccount,
      getParseStatusLabelById(a.ParseStatus),
      cutStrAtAndAddDots(a.ParseMessage, 45),
      getSystemStatusLabelById(a.SystemStatus),
      a.CreateTime,
    ];
  });
};

export default function ClientAccountsTableContainer({
  accounts,
  rowsPerPage,
  currentPage,
  totalRows,
  onChangePage,
  onChangeRowsPerPage,
}) {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    const rows = createRows(accounts);
    setRows(rows);
  }, [accounts]);
  const columns = [
    {
      name: "",
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRenderLite: (dataIndex) => {
          return (
            <IconButton
              component={Link}
              to={`/clientsaccounts/${rows[dataIndex][0]}`}
              aria-label="edit"
              size="small"
            >
              <LinkIcon sx={{ p: 0, m: 0 }} />
            </IconButton>
          );
        },
      },
    },
    {
      name: "Id",
      label: "ID",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      name: "ClientId",
      label: "Klient ID",
      options: {
        filter: false,
        empty: false,
        display: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <Link to={`/clients/${rows[dataIndex][1]}`}>
              {rows[dataIndex][1]}
            </Link>
          );
        },
      },
    },
    {
      name: "ClientTitle",
      label: "Klient Titel",
      options: {
        filter: false,
        empty: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              {rows[dataIndex][1] != null && (
                <Link to={`/clients/${rows[dataIndex][1]}`}>
                  {rows[dataIndex][2]}
                </Link>
              )}
            </>
          );
        },
      },
    },
    {
      name: "InvoiceId",
      label: "Faktura ID",
      options: {
        // filter: false,
        empty: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <Link to={`/invoices/${rows[dataIndex][3]}`}>
              {rows[dataIndex][3]}
            </Link>
          );
        },
      },
    },
    {
      name: "ClientArticleId",
      label: "Klientartikel ID",
      options: {
        // filter: false,
        empty: false,
        display: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <Link to={`/clientsarticles/${rows[dataIndex][4]}`}>
              {rows[dataIndex][4]}
            </Link>
          );
        },
      },
    },
    {
      name: "ClientArticleTitle",
      label: "Klientartikel",
      options: {
        filter: false,
        empty: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <Link to={`/clientsarticles/${rows[dataIndex][4]}`}>
              {rows[dataIndex][5]}
            </Link>
          );
        },
      },
    },
    {
      name: "Amount",
      label: "Belopp",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      label: "Betalnings ref",
      name: "PayedId",
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              {rows[dataIndex][7] > 0 ? (
                <Link to={`/clientpayments/${rows[dataIndex][7]}`}>
                  {rows[dataIndex][7]}
                </Link>
              ) : (
                rows[dataIndex][7]
              )}
            </>
          );
        },
      },
    },
    {
      label: "Bokförings ref",
      name: "BookRefId",
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              {rows[dataIndex][8] > 0 ? (
                <Link to={`/books/${rows[dataIndex][8]}`}>
                  {rows[dataIndex][8]}
                </Link>
              ) : (
                rows[dataIndex][8]
              )}
            </>
          );
        },
      },
    },
    {
      name: "Debet",
      options: {
        filter: false,
      },
    },
    {
      name: "Kredit",
      options: {
        filter: false,
      },
    },
    {
      name: "ParseStatus",
      label: "Kontrollstatus",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <CommonChip
              labelName={value}
              color={getParseStatusColorByLabel(value)}
            />
          );
        },
      },
    },
    {
      name: "ParseMessage",
      label: "Kontrollmeddelande",
      options: {
        filter: false,
      },
    },
    {
      name: "SystemStatus",
      label: "Status",
      options: {
        filter: true,
        sort: true,
        filterList: ["Aktiv"],
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <CommonChip
              labelName={value}
              color={getSystemStatusColorByLabel(value)}
            />
          );
        },
      },
    },
    {
      name: "CreateTime",
      label: "Skapad",
      options: {
        filter: false,
      },
    },
  ];

  const options = {
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    customToolbar: () => {
      return (
        <>
          <RefreshBtn />
        </>
      );
    },
    onChangePage: onChangePage
      ? (currentPage) => onChangePage(currentPage)
      : null,
    onChangeRowsPerPage: onChangeRowsPerPage
      ? (numberOfRows) => onChangeRowsPerPage(numberOfRows)
      : null,
    page: currentPage,
    rowsPerPage: rowsPerPage,
    count: totalRows,
    filterType: "dropdown",
    responsive: "standard",
    downloadOptions: {
      separator: ";",
      filename: "client_accounts.csv",
    },
    textLabels: {
      body: {
        noMatch: "",
      },
    },
    rowsPerPage: 30,
    rowsPerPageOptions: [10, 30, 100],
    onDownload: (buildHead, buildBody, columns, data) => {
      return "\uFEFF" + buildHead(columns) + buildBody(data);
    },
  };

  return (
    <MUITable options={options} title={""} data={rows} columns={columns} />
  );
}
